import { styled } from '@pulse-web-ui/theme';

export const InputContainer = styled.div`
  flex-grow: 1;
`;
